import { render, staticRenderFns } from "./settlementPriceMain.vue?vue&type=template&id=10a2cdf0&scoped=true&"
import script from "./settlementPriceMain.vue?vue&type=script&lang=js&"
export * from "./settlementPriceMain.vue?vue&type=script&lang=js&"
import style0 from "./settlementPriceMain.vue?vue&type=style&index=0&id=10a2cdf0&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a2cdf0",
  null
  
)

export default component.exports